import { render, staticRenderFns } from "./SubgroupAddDialog.vue?vue&type=template&id=3bd8f9e1&scoped=true&"
import script from "./SubgroupAddDialog.vue?vue&type=script&lang=js&"
export * from "./SubgroupAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubgroupAddDialog.vue?vue&type=style&index=0&id=3bd8f9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8f9e1",
  null
  
)

export default component.exports